import FrontendRoutesBase from './FrontendRoutesBase';
import { PAGE_TYPE, PATH_PARAM_DASHBOARD, PATH_PARAM_TOKEN } from '../PATH_PARAM';
import IFrontendRoutes from './IFrontendRoutes';

export default class SuperadminRoutes extends FrontendRoutesBase implements IFrontendRoutes {
  public root = this.getDBPath(PATH_PARAM_DASHBOARD.superadmin.root);
  public settings: SettingsRoutes;

  constructor() {
    super();
    this.settings = new SettingsRoutes(this);
  }

  getInstanceBc: IFrontendRoutes.BreadcrumbsGetter<typeof PATH_PARAM_TOKEN.superadmin> = (_p, permissions, translate) => {
    return [{ name: translate('menus.main.superadmin'), href: this.getListPath() }];
  };

  getInstanceChildBc: IFrontendRoutes.BreadcrumbsGetterWithNames<typeof PATH_PARAM_TOKEN.superadmin, 'superadminName'> = (p, pm, t, n) => {
    const breadcrumbs = this.getInfoBc(p, pm, t);
    breadcrumbs.push({ name: n.superadminName, href: this.getInfoPath(p) });
    return breadcrumbs;
  };

  getListBc = this.getEmptyBreadcrumbs;
  getListPath = () => this.getDBPath(PATH_PARAM_DASHBOARD.superadmin.root, PAGE_TYPE.list);

  getInfoBc = this.getInstanceBc;
  getInfoPath: IFrontendRoutes.PathGetter<typeof PATH_PARAM_TOKEN.superadmin> = (params) =>
    this.getDBPath(PATH_PARAM_DASHBOARD.superadmin.root, params.userId, PAGE_TYPE.info);

  getAddBc = this.getInstanceBc;
  getAddPath = () => this.getDBPath(PATH_PARAM_DASHBOARD.superadmin.root, PAGE_TYPE.new, PAGE_TYPE.add);
}

class SettingsRoutes extends FrontendRoutesBase {
  public root = this.getDBPath(PATH_PARAM_DASHBOARD.superadmin.settings);
  constructor(private parent: SuperadminRoutes) {
    super();
  }

  // getApiSettingsInfoBc = this.getInstanceBc;
  getApiSettingsInfoPath = () =>
    this.getDBPath(PATH_PARAM_DASHBOARD.superadmin.settings, PATH_PARAM_DASHBOARD.superadmin.apiSettings, PAGE_TYPE.info);

  // getReleaseNotesListBc = this.getInstanceBc;
  getReleaseNotesListPath = () =>
    this.getDBPath(PATH_PARAM_DASHBOARD.superadmin.settings, PATH_PARAM_DASHBOARD.superadmin.releaseNotes, PAGE_TYPE.list);
}